import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { func, string } from "prop-types";

import { resetPasswordConfirmationGA } from "../../../../analytics/ga";
import {
  ConfirmationWrapper,
  ModalHeading,
  ModalText,
  ModalTitle,
  SecondaryButton
} from "../../styled";

class ResetPasswordConfirmation extends React.Component {
  static propTypes = {
    scenario: string.isRequired,
    setScenario: func.isRequired
  };

  // GA starts
  componentDidMount() {
    if (localStorage.getItem("analytics")) {
      const { flow, source } = JSON.parse(localStorage.getItem("analytics"));
      resetPasswordConfirmationGA.checkEmailModalOpens(source, flow);
    }
  }
  // GA ends

  render() {
    const { scenario, setScenario } = this.props;

    return (
      <ConfirmationWrapper>
        <ModalHeading scenario={scenario}>
          <ModalTitle scenario={scenario} type="primarySm">
            Check your email
            <br /> for instructions
          </ModalTitle>
        </ModalHeading>
        <ModalText>
          <Text type="sm">
            Please contact support if you don’t receive the email or still can’t
            access your account
          </Text>
        </ModalText>
        <SecondaryButton>
          <TextLink onClick={() => setScenario("EmailCapture")}>
            Back To Sign In
          </TextLink>
        </SecondaryButton>
      </ConfirmationWrapper>
    );
  }
}

export default ResetPasswordConfirmation;
